import * as React from 'react';
import { useSelector } from 'react-redux';

import { HomeownerBlockContainer } from '../../components/HomeownerBlock';
import {
  selectIsAgencyBottomBrandingAvailable,
  selectIsByHomeowner,
  selectIsAgencyBrandingAvailable,
} from '../../selectors';
import { selectIsNewbuildingPremiumRate } from '../../selectors/newbuildingPremiumRate';
import { AuthorContainer } from '../AuthorContainer';
import { AuthorPremiumContainer } from '../AuthorPremiumContainer';
import { SubscriptionAuthorBrandContainer } from '../subscriptionBrand';

/**
 * Если компонент возвращает null, обязательно нужно добавить соответствующее условие
 * в селектор ./src/shared/selectors/offerData/selectIsBottomAgentBlockAvailable.ts
 * это необходимо для корректной работы плавающей шапки с навигацией по странице
 *
 * так же блоки должны иметь html атрибут id="author" для работы ссылок-якорей
 */
export const BottomAuthorBlockContainer = () => {
  const isByHomeowner = useSelector(selectIsByHomeowner);
  const isAgencyBrandingAvailable = useSelector(selectIsAgencyBrandingAvailable);
  const isAgencyBottomBrandingAvailable = useSelector(selectIsAgencyBottomBrandingAvailable);
  const isNewbuildingPremium = useSelector(selectIsNewbuildingPremiumRate);

  if (isByHomeowner) {
    return <HomeownerBlockContainer />;
  }

  if (isAgencyBrandingAvailable) {
    if (isAgencyBottomBrandingAvailable) {
      return <SubscriptionAuthorBrandContainer />;
    } else {
      return null;
    }
  }

  if (isNewbuildingPremium) {
    return <AuthorPremiumContainer />;
  }

  return <AuthorContainer />;
};
